/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as Types from '../../graph/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CaseCommunicationsQueryVariables = Types.Exact<{
  referenceId: Types.Scalars['String']['input'];
  timezone: Types.Scalars['String']['input'];
}>;


export type CaseCommunicationsQuery = { __typename?: 'Query', caseCommunications: Array<{ __typename?: 'CaseCommunication', type: Types.CaseCommunicationType, date: string }> };


export const CaseCommunicationsDocument = gql`
    query caseCommunications($referenceId: String!, $timezone: String!) {
  caseCommunications(referenceId: $referenceId, timezone: $timezone) {
    type
    date
  }
}
    `;

/**
 * __useCaseCommunicationsQuery__
 *
 * To run a query within a React component, call `useCaseCommunicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseCommunicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseCommunicationsQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCaseCommunicationsQuery(baseOptions: Apollo.QueryHookOptions<CaseCommunicationsQuery, CaseCommunicationsQueryVariables> & ({ variables: CaseCommunicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>(CaseCommunicationsDocument, options);
      }
export function useCaseCommunicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>(CaseCommunicationsDocument, options);
        }
export function useCaseCommunicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>(CaseCommunicationsDocument, options);
        }
export type CaseCommunicationsQueryHookResult = ReturnType<typeof useCaseCommunicationsQuery>;
export type CaseCommunicationsLazyQueryHookResult = ReturnType<typeof useCaseCommunicationsLazyQuery>;
export type CaseCommunicationsSuspenseQueryHookResult = ReturnType<typeof useCaseCommunicationsSuspenseQuery>;
export type CaseCommunicationsQueryResult = Apollo.QueryResult<CaseCommunicationsQuery, CaseCommunicationsQueryVariables>;